import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Subscription } from 'rxjs';
import { MODAL_CONTROLLER, MODAL_DATA, ModalController } from 'shared';
import { UserTrackingHelperService } from '../../../services/user-tracking-helper.service';
import { ModalComponent } from '../../../../../../shared/src/lib/components/modal/modal.component';
import { ModalContentComponent } from '../../../../../../shared/src/lib/components/modal-content/modal-content.component';
import { ModalSectionComponent } from '../../../../../../shared/src/lib/components/modal-section/modal-section.component';
import { ModalSectionColumnComponent } from '../../../../../../shared/src/lib/components/modal-section-column/modal-section-column.component';
import { InputLabelComponent } from '../../../../../../shared/src/lib/components/input-label/input-label.component';
import { InputFieldComponent } from '../../../../../../shared/src/lib/components/input-field/input-field.component';
import { ModalButtonsComponent } from '../../../../../../shared/src/lib/components/modal-buttons/modal-buttons.component';
import { Angulartics2OnModule } from 'angulartics2';
import { ModalButtonComponent } from '../../../../../../shared/src/lib/components/modal-button/modal-button.component';
import { TranslateModule } from '@ngx-translate/core';

export interface MixitSetpointModalInput {
  temperatureSetPoint: number | null;
  max: number;
  min: number;
}

export interface MixitSetpointModalResponse {
  temperatureSetPoint: number;
}

@Component({
    selector: 'app-mixit-setpoint-modal',
    templateUrl: './mixit-setpoint-modal.component.html',
    styleUrls: ['./mixit-setpoint-modal.component.scss'],
    imports: [
        ModalComponent,
        ModalContentComponent,
        FormsModule,
        ReactiveFormsModule,
        ModalSectionComponent,
        ModalSectionColumnComponent,
        InputLabelComponent,
        InputFieldComponent,
        ModalButtonsComponent,
        Angulartics2OnModule,
        ModalButtonComponent,
        TranslateModule,
    ]
})
export class MixitSetpointModalComponent implements OnInit, OnDestroy {
  private subscription = new Subscription();

  public min: number;
  public max: number;

  public form = new UntypedFormGroup({
    temperatureSetpoint: new UntypedFormControl(''),
  });

  constructor(
    @Inject(MODAL_DATA) public data: MixitSetpointModalInput,
    @Inject(MODAL_CONTROLLER) private controller: ModalController<MixitSetpointModalResponse>,
    private userTrackingHelperService: UserTrackingHelperService
  ) {}

  ngOnInit(): void {
    this.min = this.data.min;
    this.max = this.data.max;

    this.form.controls.temperatureSetpoint.setValidators([Validators.min(this.min), Validators.max(this.max)]);
    this.form.controls.temperatureSetpoint.setValue(this.data.temperatureSetPoint);

    this.subscription.add(
      this.userTrackingHelperService.startFormValueChangeTracking('adjustTemperatureSetpointConfigurationsShown', this.form)
    );
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  close() {
    this.controller.dismiss();
  }

  save() {
    this.controller.complete({ temperatureSetPoint: this.form.controls.temperatureSetpoint.value });
  }

  dismiss() {
    this.userTrackingHelperService.trackUserAction('adjustTemperatureSetpointConfigurationsShown', 'exitClicked');
  }
}
